module.exports = __webpack_public_path__ + "6dbcc560a8ade6c42163433ec292b794.jpg";